import Vue from 'vue'

Vue.filter('formatMoney', function (value) {
  if (value) {
    return 'R$ ' + value.toFixed(2).replace('.', ',').replace(/\d(?=(\d{3})+,)/g, '$&.')
  }
})



// WEBPACK FOOTER //
// ./resources/js/plugins/money_filter.js